import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Table,
  CardFooter,
  Form,
  Input
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";
import moment from 'moment';
import { useForm } from "react-hook-form";
import { Spinner } from 'reactstrap';
function ManageTrip() {
  const { id } = useParams();
  const [trip, setTrip] = useState({
    Id: 0,
    TripNumber: "",
    StartDateTime: new Date(),
    EndDatetime: new Date(),
    DriverId: "",
    Orders: "",

  });
  const [drivers, setDriver] = useState([]);
  const orders = [];
  const [assignOrdersList, setAssignOrders] = useState([]);
  const [unAssignOrder, setUnAssignOrders] = useState([]);
  const history = useHistory();
  const { register, errors, handleSubmit } = useForm()
  const [IsLoading, setIsLoading] = useState(false)
  useEffect(() => {
    loadDrivers();
    loadUnassignOrders();
    if (id) {
      loadTrip();
    }
  }, []);

  const loadDrivers = () => {
    var response = callAPI(`/api/drivers/all`, "GET", null);
    response.then((res) => {
console.log(res);
      if (res.success) {
        setDriver(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };
  const loadTrip = async () => {
    var response = callAPI(`/api/trips/${id}/0`, "GET", null);
    response.then((res) => {
      if (res.success) {
        var data = res.data[0];
        data.StartDateTime = moment(data.StartDateTime.replace(".000Z", "+05:30")).format('MM/DD/YYYY hh:mm a')
        data.EndDatetime = moment(data.EndDatetime.replace(".000Z", "+05:30")).format('MM/DD/YYYY hh:mm a')
        setTrip(data);

      } else {
        toast.error(res.message);
      }
    });
  };
  const formRef = useRef(null)
  const onInputChange = (e) => {
 
    setTrip({ ...trip, [e.target.name]: e.target.value });



  };


  const changeDriverHandler = () => {

    var response = callAPI(`/api/`, "GET", null);
    response.then((res) => {

      // if (res.success) {
      //   setDriver(res.data);
      // } else {
      //   toast.error(res.message);
      // }
    });

  }

  const onSubmit = () => {

    if (trip.StartDateTime == null) {
      toast.error("Please Enter StartDate");
    }
    else if (trip.EndDatetime == null) {
      toast.error("Please Enter EndDate");
    }
    else {

      if (trip.Id == 0 && unAssignOrder.length == 0) {
        toast.error("You can not create Trip As there is no Orders!!!");
        return;
      }

      if (trip.Id == 0 && assignOrdersList.length == 0) {
        toast.error("Please Select Orders!!!");
        return;
      }
      setIsLoading(true)
      trip.Orders = assignOrdersList.join(",");
      trip.StartDateTime = moment(trip.StartDateTime).format('MM/DD/YYYY hh:mm a')
      trip.EndDatetime = moment(trip.EndDatetime).format('MM/DD/YYYY hh:mm a')
      var response = callAPI(`/api/trips`, "POST", JSON.stringify(trip));
      response.then((res) => {
        if (res.success) {
          toast.success("Trip saved!!!");
          setTimeout(() => {
            setIsLoading(false)
            history.push("/admin/trip");
          }, 1000);
        } else {
          setIsLoading(false)
          toast.error(res.message);
        }
      })
        .catch(err => {
          setIsLoading(false)
          toast.error(err.message);
        })
    }
  }
  const handleClick = (e) => {
    e.preventDefault();
    formRef.current.props.onSubmit()
  };

  const loadUnassignOrders = () => {
    setIsLoading(true)
    var response = callAPI(`/api/orders/unassign`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        setUnAssignOrders(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  let renderDriverOptions =
    drivers.length > 0
      ? drivers.map((driver) => {
        return (
          <option key={driver.Id} value={driver.Id}>
            {driver.FullName}
          </option>
        );
      })
      : "";

  const assignOrder = (e) => {
    var index = assignOrdersList.indexOf(e.target.value);
    if (index >= 0) {
      assignOrdersList.splice(index, 1);
    } else {
      assignOrdersList.push(e.target.value);
    }
    setAssignOrders(assignOrdersList);
  };

  let renderRow = unAssignOrder.map((order) => {
    return (
      <tr key={order.Id}>
        <td className="td-actions text-left">
          <input
            type="checkbox"
            name={"chk" + order.Id}
            value={order.Id}
            onClick={(e) => assignOrder(e)}
          />
        </td>
        <td className="text-left">{order.OrderNumber}</td>
        <td className="text-left">{order.FullName}</td>
        <td className="text-left">
          {order.Address} <br />
          {order.City}, {order.State} {order.Zip} <br />
          Lat: {order.Lat} <br />
          Long: {order.Long}
        </td>
        <td className="text-left">{order.ContactNumber}</td>
      </tr>
    );
  });

  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>
      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              {/* <CardHeader>
                <CardTitle tag="h4">Order Management</CardTitle>
              </CardHeader> */}
              <CardBody>
                <Form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                  <div className="new_user">
                    <input type="hidden" name="Id" value={trip.Id} />
                    <div className="clearfix">
                      <h5 className="pull-left">Driver Information</h5>
                      <div className="form-group pull-right">
                        <Button
                          type="button"
                          onClick={(e) => handleClick(e)}
                          className="btn btn-info"
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="DriverId" className="text-dark">
                            Driver:
                          </label>

                          <Input
                            type="select"
                            name="DriverId"
                            className="form-control"
                            value={trip.DriverId}
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.DriverId && true}
                          >
                            <option value="">Select Driver</option>
                            { }
                           {renderDriverOptions} 
                          </Input>
                        </div>
                      </Col>
                    </Row>
                    <h5>Trip Schedule Information</h5>
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="StartDateTime" className="text-dark">
                            Start:
                          </label>
                          <DateTimePickerComponent
                            name="StartDateTime"
                            value={new Date(trip.StartDateTime)}
                            min={new Date()}
                            onChange={(e) => onInputChange(e)}

                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="EndDatetime" className="text-dark">
                            End:
                          </label>
                          <DateTimePickerComponent
                            name="EndDatetime"
                            value={new Date(trip.EndDatetime)}
                            min={new Date(trip.StartDateTime)}
                            onChange={(e) => onInputChange(e)}

                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            {unAssignOrder.length > 0 ? (
              <Card className="card-chart">
                <CardHeader>
                  <CardTitle tag="h4">Unassign Orders</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Action</th>
                        <th>Order Number</th>
                        <th>Receiver Name</th>
                        <th>Address</th>
                        <th>Contact Number</th>
                      </tr>
                    </thead>
                    <tbody>{renderRow}</tbody>
                  </Table>
                </CardBody>
                <CardFooter>
                  <div className="stats"></div>
                </CardFooter>
              </Card>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ManageTrip;
